<template>
    <section class="sharing_wrap">
        <h1 class="hide">정보공유 홈</h1>
        <ShareInfoHeader 
            ref="shareInfoHeader"  
            @noneReadShareInfo="noneReadShareInfo"  
        />
        <div class="tab_ty1" id="tabs"> 
            <div class="tab-menu">
            <div class="inner">
              <ul>
                  <li v-for="(tab, index) in categoryListTabs" v-bind:class="{active:currentTab===tab.index}" :key="'category_'+index">
                      <button type="button" v-on:click="selectTab(tab)" class="ell-singleline">{{tab.name}}</button>
                      <div class="tooltip-b tl small" v-if="checkTabLength(tab.name)">{{tab.name}}</div>
                  </li>
              </ul>
              <div class="dropdown ty1 right" v-if="categoryListSelectBox.length != 0">
                  <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                          <v-btn v-bind="attrs" v-on="on">{{ $i18nUtil.trans("message.ShareInfo.002","전체보기") }}({{categoryListSelectBox.length}})</v-btn>
                      </template>
                      <div class="dropdown-list">
                          <dl>
                              <dt>{{ $i18nUtil.trans("message.ShareInfo.003","전체 카테고리") }} ({{categoryListSelectBox.length}})</dt>
                              <dd>
                                  <ul class="scroll" style="height: 490px;">
                                      <li v-for="(tab , index ) in categoryListSelectBox" :key="'selectBoxCategory_'+index" >
                                          <button type="button" class="ell-singleline" @click="selectTab(tab)">{{tab.name}}</button>
                                          <div class="tooltip-b tl small" v-if="checkTabLength(tab.name)">{{tab.name}}</div>
                                      </li> 
                                  </ul>
                              </dd>
                          </dl>
                      </div>
                  </v-menu>
              </div>
            </div> 
          </div>
            
            <!-- 전체 탭 화면  -->
            <div class="tab-content">
                <SharingAll 
                    ref='sharingContents0'
                    v-if="currentTab == 0"
                    :circleBoardList="circleBoardList"
                    :categoryList="categoryList"
                    :filterCategoryInfo="filterCategoryInfo"
                    :myUserId="myUserId"
                    :headerNoneRead="headerNoneRead"
                    @moveCategoryMore="moveCategoryMore"/> 
                <SharingCircleContents
                    :ref="'sharingContents'+(index + 1)"
                    v-for="(category , index ) in circleBoardList"
                    :key="'circleBoard+'+index"
                    v-show="currentTab == (index + 1)"
                    :categoryMid="category.boardId"
                    :categoryName="category.boardNm"
                    :myUserId="myUserId"
                    :headerNoneRead="headerNoneRead">
                </SharingCircleContents>
                <!-- <SharingContents 
                    :ref="'sharingContents'+(index+1+circleBoardIdCnt)"   
                    v-for="(category , index ) in categoryList" 
                    :key="'shareBoard+'+index"
                    v-show="currentTab == (index+1+circleBoardIdCnt)"
                    :categoryInfo="category"
                    :myUserId="myUserId">
                </SharingContents> -->
                <SharingContents  
                    v-if="currentTab > circleBoardIdCnt"
                    :category="category"
                    :myUserId="myUserId"
                    :headerNoneRead="headerNoneRead">
                </SharingContents>
            </div> 
            
            <!-- 서클 탭 상세   -->
            <!-- <div class="tab-content" v-for="(category , index ) in circleBoardList" :key="'circleBoard+'+index">
                 <SharingCircleContents 
                    :ref="'sharingContents'+(index + 1)"
                    v-show="currentTab == (index + 1)"
                    :categoryMid="category.boardId"
                    :categoryName="category.boardNm">
                </SharingCircleContents>
            </div> -->

            <!-- 정보공유 탭 상세 -->
            <!-- <div class="tab-content" v-for="(category , index ) in categoryList" :key="'shareBoard+'+index">
                 <SharingContents 
                    :ref="'sharingContents'+(index+1+circleBoardIdCnt)"   
                    v-show="currentTab == (index+1+circleBoardIdCnt)"
                    :categoryInfo="category" /> 
            </div> -->

        </div>
        <modals-container
            @board_Regist="addBoard"
        ></modals-container> 
    </section>
</template>

<script>
//메인 관련 css 
import { mapState, mapActions, mapMutations } from "vuex";
import ShareInfoHeader from "./ShareInfoHeader"; 

//본문 컴포넌트 
import SharingAll from "./SharingAll";  
import SharingContents from "./SharingContents";
import SharingCircleContents from "./SharingCircleContents"

import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// Navigation error로 아래 내용으로 대체
import {Swiper as SwiperClass, Scrollbar, Navigation} from 'swiper/swiper.esm.js'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
// Swiper modules
SwiperClass.use([Scrollbar, Navigation])
// local component
const {directive} = getAwesomeSwiper(SwiperClass)

export default {
    name: 'tabs',
    directives: {
        swiper: directive
    },
    components: {
        ShareInfoHeader,
        SharingContents,
        SharingCircleContents,
        SharingAll, 
    },
    data() {
        return {
            //currentTab: 0,
            tabs: [],
            swiperOption: {
                slidesPerView: 5,
                spaceBetween: 0,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                }
            },

            //
            category:[],
            currentTab: -1,
            categoryListTabs: [],
            categoryListSelectBox : [],
            categoryList: [], 
            url: null,
            method: null,
            req: {},
            circleBoardList: [],
            circleBoardIdCnt: 0,  

            myUserId:'', 
            filterCategoryInfo:[],
            filterInfoBuffer:[],
            filterCategoryMids:[],

            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            }, 

            headerNoneRead:false,
        };
    },
    mounted() {
        /* 카테고리 리스트 조회 */
        this.getCircleBoardIdList();
        //정보공유 관리자 인지 판단 & 관리자가아니라면 운영자권한인 카테고리 개수 조회.
        this.getShareInfoManageYn();

        // 뒤로가기 이벤트 발생시 .
        const self = this;
        window.onpopstate = function (event) {
            // 호출|알림 팝업 띄우기위한 값.
            self.setEventBackYn(true);
            let returnUrls = localStorage.getItem("returnUrls");
            if(returnUrls != null) {
                let urlList = returnUrls.split(",");
                if (urlList.length > 0) {
                    if (urlList.length == 1) {
                        localStorage.removeItem("returnUrls");
                        // self.$router.push("/general/home");
                    } else {
                        urlList.pop();
                        urlList.pop();
                        localStorage.setItem("returnUrls", urlList);
                        // this.$router.replace(urlList[urlList.length-1]);
                    }
                } else {
                    self.$router.push("/general/home");
                }
            }else{
                self.$router.push("/general/home");
            }
        }

    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    methods:{
        ...mapMutations("shareInfo", ["setShareBoardCount"]),
        ...mapMutations("shareInfo", ["setNoneReadCount"]),
        ...mapMutations("shareInfo", ["setShareInfoManageYn"]),
        ...mapMutations("shareInfo", ["setShareInfoManageCategoryCount"]),
        ...mapActions("modals", ["showToast", "showModal"]),
        ...mapActions("restAction", ["COWORK_REST_ACTION"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("noti", ["setEventBackYn"]),
        /* 서클 보드목록 조회 */
        getCircleBoardIdList() { 
            let obj = this;
            obj.categoryListTabs=[];
            let reqData = {
                url: "/api/copaper/cicle/getCircleBoardIdList",
                method: "post",
            }; 
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {  
                let list = res.result;
                // list.forEach((element) => { 
                    // obj.categoryListTabs.push(element.boardNm);  
                    //서클 게시판 카테고리의 유저정보가 없음.
                    // if(obj.filterCategoryMids.indexOf(element.boardId) == -1 ){
                    //     let param ={
                    //         categoryMid : element.boardId,
                    //         categoryName : element.boardNm,
                    //        /*  regUserId : element.userId,
                    //         regUserName : element.userName,
                    //         modUserId : element.userId,
                    //         modUserName : element.userName, */
                    //     }
                    //     obj.filterCategoryMids.push(element.boardId);
                    //     obj.filterInfoBuffer.push(param);
                    // }
                // }); 
                obj.circleBoardList = list;
                obj.circleBoardIdCnt = list.length;

                this.getShareCategoryList();

                // 전체보드수 , 미확인 보드수 초기화 
                obj.setShareBoardCount(-1);
                obj.setNoneReadCount(-1);
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        /* 카테고리 리스트 조회 */
        getShareCategoryList() {
            
            let obj = this; 
            let reqData = {
                url: "/api/copaper/infoshare/getShareCategoryListWithAuth",
                method: "post",
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {      
                obj.myUserId = res.result.userId;
                let list = res.result.categoryList;
                // list.forEach((element) => {  
                //     obj.categoryListTabs.push(element.categoryName);  
                //     if(obj.filterCategoryMids.indexOf(element.categoryMid) == -1 ){
                //         let param ={
                //             categoryMid : element.categoryMid,
                //             categoryName : element.categoryName,
                //             regUserId : element.regUserId,
                //             regUserName : element.regUserName,
                //             modUserId : element.modUserId,
                //             modUserName : element.modUserName,
                //         }  
                //         obj.filterCategoryMids.push(element.categoryMid);
                //         obj.filterInfoBuffer.push(param);
                //     }
                // });

                // for (let i = 0; i < 4; i++) { 
                //     obj.categoryListTabs.push(list[i].categoryName);
                // }
                obj.categoryListTabs.push({name:obj.$i18nUtil.trans("message.ShareInfo.001","전체"), index:0})
                for(let k in list){
                    if(k < 4){
                        let data = {
                            categoryMid : list[k].categoryMid,
                            name : list[k].categoryName,
                            index : (k*1)+1
                        }
                        obj.categoryListTabs.push(data);
                    }

                    let data = {
                        categoryMid : list[k].categoryMid,
                        name : list[k].categoryName,
                        index : (k*1)+1
                    }
                    obj.categoryListSelectBox.push(data);
                   
                }

                obj.filterCategoryInfo = obj.filterInfoBuffer;
                obj.categoryList = list;  
                
                let localState = JSON.parse(window.sessionStorage.getItem("shareInfo"));
                if(localState != null){
                    obj.$nextTick(function(){
                        obj.categoryListSelectBox.filter(function(category){
                            if(category.categoryMid == localState.categoryMid){
                                obj.currentTab = category.index;
                                obj.selectTab(category); 
                            }
                        })
                        //카테고리홈 재접속시 탭선택되는것을 막기위해 제거.
                        window.sessionStorage.removeItem("shareInfo");
                    })
                } else{ 
                    obj.currentTab= 0;
                }
            })
            .catch(function (err) {
                console.log(err);
            }); 
        },
        selectTab(tab){  
            
            if(this.currentTab != tab.index){ 
                this.setNoneReadCount(-1);  
            } 
            this.currentTab = tab.index;
            if(tab.index != 0 && tab.index < 1+this.circleBoardIdCnt){
                let refsName = 'sharingContents'+tab.index; 
                this.$refs[refsName][0].getBoardList(); 
                this.$refs.shareInfoHeader.setType("TAB"); 
            }else if(tab.index >= (1+this.circleBoardIdCnt)){   
                this.category = this.categoryList[tab.index-1];  
                this.$refs.shareInfoHeader.setType("TAB");  
                if(tab.index >= 4){ 
                    let moveTab = this.categoryListTabs.pop();  
                    this.categoryListTabs.push(tab);   
                } 
            }else{ 
                //this.getCircleBoardIdList();
                this.categoryList.push(); 
                this.$refs.shareInfoHeader.setType("ALL"); 
            }
        },
        addBoard(_data){  
            let obj = this;
            let reqData = {};
            reqData.params = {
                paperTitle: _data.boardName,
                paperId: _data.paperId,
                groupId: _data.category.groupId,
                categoryMid: _data.category.categoryMid,
                contentPath: _data.contentPath, 
                docGrade: _data.docGrade,
                blockType: "CONTENT",
                postYn: "1",
                link: "/general/board/" + _data.paperId,
                tagList: _data.tagList
            }; 
            reqData.req = obj.req;
            reqData.url = "/api/copaper/paper/addPaper";
            reqData.method = "post";
            //프로그레스바 시작 
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => { 
                    //프로그레스바 종료
                    this.hideLoadingbar();
                    if(res.errorCode != null){
                        return;
                    }else{
                        let state = {
                            categoryName : _data.category.categoryName,
                            categoryMid : _data.category.categoryMid
                        }
                        window.sessionStorage.setItem("shareInfo",JSON.stringify(state));
                        this.toastInfo.message = this.$i18nUtil.trans("TB036.002"); //"보드가 저장되었습니다.";
                        this.showToast(this.toastInfo);
                        let newBoard = res.result;
                        this.$router.push("/general/board/" + newBoard); 
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        getShareInfoManageYn(){
            let obj = this; 
            let reqData = {};
            reqData.params ={
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/getShareCategoryManagerYn";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if (res.errorCode != null) {
                } else { 
                    if (res.result == null) {
                        let shareInfoManageYn = false;
                        obj.setShareInfoManageYn(shareInfoManageYn);
                        obj.setShareInfoManageCount();
                    } else {
                        let shareInfoManageYn = true;
                        obj.setShareInfoManageYn(shareInfoManageYn);
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        setShareInfoManageCount(){
            let obj = this; 
            let reqData = {};
            reqData.params ={
            }
            reqData.req = obj.req;
            reqData.url = "/api/copaper/infoshare/getMyShareInfoManageCount";
            reqData.method = "post";
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if (res.errorCode != null) {
                } else {   
                    obj.setShareInfoManageCategoryCount(res.result); 
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        noneReadShareInfo(){ 
            this.headerNoneRead = !this.headerNoneRead;
        },
        moveCategoryMore(_categoryInfo){ 
            let selectedCategoryIndex = 0;
            for(let k in this.categoryList){
                if(this.categoryList[k].categoryMid == _categoryInfo.categoryMid){ 
                    selectedCategoryIndex = (k*1)+1;
                }
            } 
            let data = {
                index : selectedCategoryIndex,
                name : _categoryInfo.categoryName      
            } 
            this.currentTab = selectedCategoryIndex; 
            this.selectTab(data);

        },
        checkTabLength(categoryName){
            let byteLength = 24;
            let checkBytes = this.getByteLength(categoryName);
            if(checkBytes > byteLength) {
              return true;
            }else{
                return false;
            }
        }, 
        getByteLength(str) {
            if (str == null || str.length == 0) {
                return 0;
            }
            var size = 0;
            for ( var i = 0; i < str.length; i++) {
                size += this.charByteSize(str.charAt(i));
            }
            return size;
        }, 
        charByteSize(ch) {
            if (ch == null || ch.length == 0) {
                return 0;
            }
            var charCode = ch.charCodeAt(0);

            if (charCode <= 0x00007F) {
                return 1;
            } else if (charCode <= 0x0007FF) {
                return 2;
            } else if (charCode <= 0x00FFFF) {
                return 2;
            } else {
                return 2;
            }
        },
    },
};
</script>

<style scoped>
.sharing_wrap .tab_ty1 > .tab-menu .inner > ul > li > button + .tooltip-b, .cooperation .tab_ty1 > .tab-menu .inner > ul > li > button + .tooltip-b {
    max-width: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/shareInfo/base/ShareInfo.vue